export default "__VITE_ASSET__BMicPCfB__"